import React, { useState } from 'react';
//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const AlertConfirm = (props) => {
  const [alertOpen, setAlertOpen] = useState(false);

  const {
    open = alertOpen,
    setOpen = setAlertOpen,
    title = '',
    text = '',
    setvoucher = '',
    callback,
  } = props;

  const handleClose = () => {
    setvoucher('');
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'>
      <DialogTitle id='alert-dialog-slide-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-slide-description'>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Cancelar
        </Button>
        <Button
          onClick={() => {
            if (callback) callback();
          }}
          color='primary'
          autoFocus>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertConfirm;
